import {
  audienceBuilderEdgeMap,
  audienceBuilderNodeMap,
} from '@gl/lit/common/constants/builders/audience_builder.js';
import type {GraphologyConfig} from '@gl/lit/lib/builder/stores/graphology.js';
import {GraphologyStore} from '@gl/lit/lib/builder/stores/graphology.js';
import {Channel} from '@gl/utils/channel.js';
import {AudienceBuilderTemplateKeys} from '@gl/lit/types/builders/audience_builder/index.js';
import {AudienceBuilder} from './builder.js';
import {defaultTemplate} from './templates/default_template.js';

export const AUDIENCE_BUILDER_KEY = 'ab';

const channel = Channel.create('ab:internal');
const config: GraphologyConfig = {
  nodeClassMap: audienceBuilderNodeMap,
  edgeClassMap: audienceBuilderEdgeMap,
};

const store = GraphologyStore.create({config});

export const audienceBuilder = new AudienceBuilder({
  key: AUDIENCE_BUILDER_KEY,
  store,
  channel,
  // TODO(joshua): Remove 1-level nest level after advanced joins is enabled globally
  nestLimit: 1,
});

/**
 * Register all templates.
 */
audienceBuilder.setTemplates({
  [AudienceBuilderTemplateKeys.DEFAULT]: defaultTemplate,
});
